/* Sherri Hill 2026 — product page (sections/sh2-product.liquid).
   Colour/size state, swipe counter, tap-to-play video, size guide + Find In Store dialogs, desktop image viewer,
   phones' sticky bar, You May Also Like, and the store search (Sherri Hill store API; Google Places only once the
   Find In Store panel opens). */
(function () {
  'use strict';
  var STORE_API = 'https://api.sherrihill.com/get-product-store-address';
  var MAPS_SRC = 'https://maps.googleapis.com/maps/api/js?libraries=places&key=AIzaSyCZrpXaykWqPoymLb1bAJX5UZt0PIf4ci8';
  var TIPS = ["Don't be shy! Call any store near you to ask about your favorite dress.", "Stores don't always have every color and size on hand. Ask any authorized Sherri Hill retailer to check whether your color and size is available to order."];
  var mqDesk = window.matchMedia('(min-width: 768px)');
  var quiet = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  function init(root) {
    if (root.dataset.sh2Init) return;
    root.dataset.sh2Init = '1';
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-sh2-product-json]').textContent); } catch (e) {}
    var style = data.style || root.getAttribute('data-style');
    var isUS = root.getAttribute('data-us') === 'true';
    var $ = function (s, el) { return (el || root).querySelector(s); };
    var $$ = function (s, el) { return [].slice.call((el || root).querySelectorAll(s)); };

    /* ---------- State ---------- */
    var state = { color: '', size: '' };
    var colorInputs = $$('[data-sh2-color]');
    var sizeInputs = $$('[data-sh2-size]');
    colorInputs.forEach(function (i) { if (i.checked) state.color = i.value; });
    sizeInputs.forEach(function (i) { if (i.checked) state.size = i.value; });
    function colorBg() { var c = colorInputs.filter(function (i) { return i.checked; })[0]; return c ? c.getAttribute('data-bg') : ''; }
    function variant() {
      if (!data.variants) return null;
      return data.variants.filter(function (v) {
        return (data.colorIndex == null || v.options[data.colorIndex] === state.color) && (data.sizeIndex == null || v.options[data.sizeIndex] === state.size);
      })[0] || null;
    }
    function render() {
      var cl = $('[data-sh2-color-label]'); if (cl) cl.textContent = state.color;
      var sl = $('[data-sh2-size-label]'); if (sl) sl.textContent = state.size || 'Select';
      var sc = $('[data-sh2-sticky-color]'); if (sc) sc.textContent = state.color;
      var ss = $('[data-sh2-sticky-size]'); if (ss) ss.textContent = state.size ? 'Size ' + state.size : 'Choose a size';
      var sd = $('[data-sh2-sticky-dot]'); if (sd) sd.style.background = colorBg();
      var note = $('[data-sh2-action-note]');
      if (note) note.textContent = state.size
        ? 'See which authorized retailers near you may carry Style #' + style + ' in ' + state.color + ', size ' + state.size + '.'
        : 'Choose a color and size, then see which authorized retailers near you may carry it.';
      var v = variant();
      var price = $('[data-sh2-price]'); if (price && v) price.textContent = v.price;
      var add = $('[data-sh2-add]'), vid = $('[data-sh2-variant-id]');
      if (add) {
        if (!state.size) { add.disabled = true; add.textContent = 'Select A Size To Add To Bag'; }
        else if (!v || !v.available) { add.disabled = true; add.textContent = 'Sold Out'; }
        else { add.disabled = false; add.textContent = 'Add To Bag'; }
        if (vid) vid.value = v ? v.id : '';
      }
      $$('[data-sh2-sizeguide] tr[data-size]').forEach(function (tr) { tr.classList.toggle('is-selected', tr.getAttribute('data-size') === state.size); });
      var sel = $('[data-sh2-loc-sel]'); if (sel) sel.textContent = state.color + (state.size ? ' · Size ' + state.size : ' · Choose a size');
      var edit = $('[data-sh2-loc-edit]'); if (edit) edit.hidden = !state.size;
      if (!state.size) showLocOptions(true);
      var empty = $('[data-sh2-loc-empty]');
      if (empty) empty.textContent = state.size
        ? 'Enter a city, street or ZIP code to see authorized Sherri Hill retailers near you that may carry Style #' + style + ' in ' + state.color + ', size ' + state.size + '.'
        : 'Choose your size above, then search for authorized retailers near you.';
      $$('[data-sh2-loc-q], [data-sh2-loc-form] button, [data-sh2-loc-geo]').forEach(function (el) { el.disabled = !state.size; });
    }
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-sh2-color]')) { state.color = t.value; syncCopies(); render(); rerun(); }
      if (t.matches('[data-sh2-size]')) { state.size = t.value; syncCopies(); render(); rerun(); }
    });

    /* ---------- Gallery: counter + tap video ---------- */
    var track = $('[data-sh2-track]'), count = $('[data-sh2-count]');
    if (track && count) track.addEventListener('scroll', function () {
      var w = track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 2 : 1;
      count.textContent = Math.min(Math.round(track.scrollLeft / w) + 1, track.children.length);
    }, { passive: true });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sh2-play]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var box = b.closest('[data-sh2-tapvideo]');
      var v = box.querySelector('video');
      if (!v) {
        v = document.createElement('video');
        v.className = 'sh2-media__video'; v.muted = true; v.loop = true; v.playsInline = true;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
        v.src = box.getAttribute('data-src');
        v.addEventListener('playing', function () { box.classList.add('is-playing'); b.setAttribute('aria-label', 'Pause video'); });
        v.addEventListener('pause', function () { box.classList.remove('is-playing'); b.setAttribute('aria-label', 'Play video'); });
        box.insertBefore(v, b);
      }
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
    });

    /* ---------- Dialogs (size guide, Find In Store) ---------- */
    var openDlg = null, lastFocus = null;
    function open(name) {
      var d = $('[data-sh2-dialog="' + name + '"]');
      if (!d) return;
      if (openDlg) close(true);
      lastFocus = document.activeElement;
      d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      openDlg = d;
      var c = d.querySelector('[data-sh2-close].sh2-drawer__close'); if (c) c.focus({ preventScroll: true });
      if (name === 'locator') onLocatorOpen();
      sticky();
    }
    function close(silent) {
      if (!openDlg) return;
      openDlg.classList.remove('is-open'); openDlg.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      openDlg = null;
      if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      if (location.hash === '#size-guide') history.replaceState(null, '', location.pathname + location.search);
      sticky();
    }
    root.addEventListener('click', function (e) {
      var o = e.target.closest('[data-sh2-open]');
      if (o) { e.preventDefault(); open(o.getAttribute('data-sh2-open')); return; }
      if (e.target.closest('[data-sh2-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (lbOpen) closeLb(); else close(); } });
    if (location.hash === '#size-guide') open('size-guide');
    $$('[data-sh2-unit]').forEach(function (b) {
      b.addEventListener('click', function () {
        var u = b.getAttribute('data-sh2-unit');
        $$('[data-sh2-unit]').forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on); });
        $$('[data-sh2-table]').forEach(function (t) { t.hidden = t.getAttribute('data-sh2-table') !== u; });
      });
    });

    /* ---------- Sticky bar (phones) ---------- */
    var bar = $('[data-sh2-sticky]'), opts = $('[data-sh2-options]');
    function sticky() {
      if (!bar || !opts) return;
      var show = !mqDesk.matches && !openDlg && opts.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', !show);
      $$('button', bar).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    }
    window.addEventListener('scroll', sticky, { passive: true });
    var edit = $('[data-sh2-edit]');
    if (edit) edit.addEventListener('click', function () { window.scrollTo({ top: opts.getBoundingClientRect().top + window.scrollY - 72, behavior: quiet() ? 'auto' : 'smooth' }); });

    /* ---------- Image viewer (desktop) ---------- */
    var lb = $('[data-sh2-lightbox]'), lbOpen = false, lbI = 0, zoom = false;
    var imgs = data.images || [];
    function showLb(i) {
      lbI = (i + imgs.length) % imgs.length; zoom = false;
      var im = $('[data-sh2-lb-img]', lb);
      im.src = imgs[lbI].full; im.alt = imgs[lbI].alt || '';
      im.style.transform = 'none';
      $('[data-sh2-lb-stage]', lb).classList.remove('is-zoomed');
      $('[data-sh2-lb-i]', lb).textContent = lbI + 1;
      $('[data-sh2-lb-hint]', lb).textContent = 'Click the image to zoom';
      $$('[data-sh2-lb-thumb]', lb).forEach(function (t) { t.classList.toggle('is-active', +t.getAttribute('data-sh2-lb-thumb') === lbI); });
    }
    function closeLb() { lbOpen = false; lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus({ preventScroll: true }); }
    if (lb && imgs.length) {
      root.addEventListener('click', function (e) {
        var z = e.target.closest('[data-sh2-zoom]');
        if (!z || !mqDesk.matches) return;
        lastFocus = z; lbOpen = true;
        showLb(+z.getAttribute('data-sh2-zoom'));
        lb.classList.add('is-open'); lb.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        $('[data-sh2-lb-close]', lb).focus({ preventScroll: true });
      });
      $('[data-sh2-lb-close]', lb).addEventListener('click', closeLb);
      $$('[data-sh2-lb-go]', lb).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); showLb(lbI + (+b.getAttribute('data-sh2-lb-go'))); }); });
      $$('[data-sh2-lb-thumb]', lb).forEach(function (b) { b.addEventListener('click', function () { showLb(+b.getAttribute('data-sh2-lb-thumb')); }); });
      var stage = $('[data-sh2-lb-stage]', lb), im = $('[data-sh2-lb-img]', lb);
      var move = function (e) { var r = stage.getBoundingClientRect(); im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; };
      stage.addEventListener('click', function (e) {
        if (e.target.closest('[data-sh2-lb-go]')) return;
        move(e); zoom = !zoom;
        stage.classList.toggle('is-zoomed', zoom);
        im.style.transform = zoom ? 'scale(2.4)' : 'none';
        $('[data-sh2-lb-hint]', lb).textContent = zoom ? 'Click to zoom out' : 'Click the image to zoom';
      });
      stage.addEventListener('mousemove', function (e) { if (zoom) move(e); });
      document.addEventListener('keydown', function (e) { if (!lbOpen) return; if (e.key === 'ArrowRight') showLb(lbI + 1); if (e.key === 'ArrowLeft') showLb(lbI - 1); });
    }

    /* ---------- Find In Store ---------- */
    var locOpts = $('[data-sh2-loc-options]'), locSlot = $('[data-sh2-loc-options-slot]');
    var results = $('[data-sh2-loc-results]'), statusEl = $('[data-sh2-loc-status]');
    var qInput = $('[data-sh2-loc-q]'), lastSearch = null, place = null;
    /* A compact copy of the size (and colour) pickers inside the panel, kept in sync with the page */
    if (locSlot) {
      var copy = $('.sh2-options').cloneNode(true);
      $$('input', copy).forEach(function (i) { i.name = i.name + '-loc'; i.removeAttribute('id'); });
      $$('.sh2-options__guide, .sh2-options__note', copy).forEach(function (x) { x.remove(); });
      locSlot.appendChild(copy);
      copy.addEventListener('change', function (e) {
        var t = e.target;
        var page = (t.matches('[data-sh2-color]') ? colorInputs : sizeInputs).filter(function (i) { return i.value === t.value; })[0];
        if (page) { page.checked = true; page.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    }
    function syncCopies() {
      if (!locSlot) return;
      $$('input', locSlot).forEach(function (i) { i.checked = i.matches('[data-sh2-color]') ? i.value === state.color : i.value === state.size; });
      $$('[data-sh2-color-label]', locSlot).forEach(function (x) { x.textContent = state.color; });
      $$('[data-sh2-size-label]', locSlot).forEach(function (x) { x.textContent = state.size || 'Select'; });
    }
    function showLocOptions(on) {
      if (!locOpts) return;
      locOpts.hidden = !on;
      var ed = $('[data-sh2-loc-edit]');
      if (ed) { ed.setAttribute('aria-expanded', on); ed.textContent = on ? 'Done' : 'Change'; }
    }
    var ed = $('[data-sh2-loc-edit]');
    if (ed) ed.addEventListener('click', function () { showLocOptions(locOpts.hidden); });

    var mapsP = null;
    function loadMaps() {
      if (window.google && window.google.maps && window.google.maps.places && window.google.maps.places.PlacesService) return Promise.resolve();
      if (mapsP) return mapsP;
      mapsP = new Promise(function (res, rej) {
        var s = document.createElement('script');
        s.src = MAPS_SRC; s.async = true; s.onerror = rej;
        /* the places library can arrive a moment after the loader script itself */
        s.onload = function () {
          var n = 0;
          (function wait() {
            if (window.google && google.maps && google.maps.places && google.maps.places.PlacesService) res();
            else if (++n > 100) rej(new Error('places'));
            else setTimeout(wait, 100);
          })();
        };
        document.body.appendChild(s); /* body, not head: the theme's Find In Store loader only holds head scripts */
      });
      return mapsP;
    }
    /* The panel always opens with results, like the old one: the shopper's approximate location from their IP
       (ipapi.co, the same lookup the old panel used; no permission prompt), then the store API lists the stores that
       may have the dress and the nearest other stores. If the lookup fails, the API is asked without a location.
       A city / ZIP / current location search replaces it. */
    var NOLOC = { none: true, label: '' };
    var ipLoc = null;
    function autoSearch() {
      if (ipLoc) { search(ipLoc); return; }
      setStatus('Finding authorized retailers near you…'); skeleton();
      var done = false;
      var fallback = setTimeout(function () { if (!done) { done = true; search(NOLOC); } }, 3500);
      fetch('https://ipapi.co/json/').then(function (r) { return r.json(); }).then(function (j) {
        if (done) return;
        done = true; clearTimeout(fallback);
        var lat = parseFloat(j.latitude), lng = parseFloat(j.longitude);
        if (isNaN(lat) || isNaN(lng)) { search(NOLOC); return; }
        ipLoc = { lat: lat, lng: lng, label: [j.city, j.region_code || j.region].filter(Boolean).join(', ') || 'you', approx: true };
        search(ipLoc);
      }).catch(function () { if (!done) { done = true; clearTimeout(fallback); search(NOLOC); } });
    }
    function onLocatorOpen() {
      syncCopies();
      showLocOptions(!state.size);
      if (state.size && !lastSearch) autoSearch();
      loadMaps().then(function () {
        if (!qInput || qInput.dataset.ac) return;
        qInput.dataset.ac = '1';
        var ac = new google.maps.places.Autocomplete(qInput, { types: ['geocode'], fields: ['geometry', 'formatted_address', 'name'] });
        ac.addListener('place_changed', function () {
          var p = ac.getPlace();
          if (p && p.geometry) { place = { lat: p.geometry.location.lat(), lng: p.geometry.location.lng(), label: p.formatted_address || p.name }; search(place); }
        });
      }).catch(function () {});
    }
    var form = $('[data-sh2-loc-form]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = qInput.value.trim();
      if (!state.size) { showLocOptions(true); setStatus('Choose a size first.'); return; }
      if (!q) return;
      if (place && place.label === q) { search(place); return; }
      setStatus('Searching authorized retailers near ' + q + '…'); skeleton();
      loadMaps().then(function () {
        /* Places text search (the Geocoding API isn't enabled on this key; Places is) */
        new google.maps.places.PlacesService(document.createElement('div')).findPlaceFromQuery({ query: q, fields: ['geometry', 'formatted_address'] }, function (r, st) {
          if (st === 'OK' && r && r[0] && r[0].geometry) { place = { lat: r[0].geometry.location.lat(), lng: r[0].geometry.location.lng(), label: q }; search(place); }
          else { setStatus(''); none(q, 'We couldn’t find that place. Pick a suggestion from the list, or try a city or ZIP code.'); }
        });
      }).catch(function () { setStatus(''); none(q, 'Store search is unavailable right now. Please try again.'); });
    });
    var geo = $('[data-sh2-loc-geo]');
    if (geo) geo.addEventListener('click', function () {
      if (!state.size) { showLocOptions(true); setStatus('Choose a size first.'); return; }
      if (!navigator.geolocation) return;
      setStatus('Finding your location…');
      navigator.geolocation.getCurrentPosition(function (pos) {
        qInput.value = 'Current location';
        search({ lat: pos.coords.latitude, lng: pos.coords.longitude, label: 'your location' });
      }, function () { setStatus('We couldn’t get your location. Search a city or ZIP code instead.'); });
    });
    function setStatus(t) { if (statusEl) statusEl.textContent = t; }
    function skeleton() {
      var rows = '';
      for (var i = 0; i < 3; i++) rows += '<div class="sh2-skel-row"><span class="sh2-skel" style="width:55%;height:16px"></span><span class="sh2-skel" style="width:80%"></span><span class="sh2-skel" style="width:40%"></span></div>';
      results.innerHTML = '<div class="sh2-locator__section" aria-hidden="true"><span class="sh2-skel sh2-skel--title"></span><div>' + rows + '</div></div>';
    }
    function rerun() {
      if (!state.size) return;
      if (lastSearch) search(lastSearch);
      else if (openDlg && openDlg.getAttribute('data-sh2-dialog') === 'locator') autoSearch();
    }
    function storeHTML(s, compact) {
      var addr = [s.address1, s.address2].filter(Boolean).join(', ');
      var city = [s.city, [s.state_code, s.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');
      var phone = s.phone_number || '';
      var dest = encodeURIComponent(s.full_address || (addr + ', ' + city));
      var hours = '';
      if (!compact && s.show_store_hours && s.store_hours && typeof s.store_hours === 'object') {
        var rows = Object.keys(s.store_hours).map(function (d) { return '<dt>' + esc(d) + '</dt><dd>' + esc(s.store_hours[d]) + '</dd>'; }).join('');
        if (rows) hours = '<details class="sh2-store__hours"><summary>Store Hours</summary><dl>' + rows + '</dl></details>';
      }
      return '<li class="sh2-store"><h4 class="sh2-store__name">' + esc(s.store_name) + '</h4>' +
        '<span class="sh2-store__dist">' + (s.distance != null ? parseInt(s.distance, 10) + ' mi' : '') + '</span>' +
        '<address class="sh2-store__addr">' + esc(addr) + '<br>' + esc(city) + '</address>' + hours +
        '<div class="sh2-store__actions">' + (phone ? '<a class="sh2-store__phone" href="tel:' + esc(phone.replace(/[^0-9+]/g, '')) + '">' + esc(phone) + '</a>' : '') +
        '<a class="sh2-label sh2-store__dir" href="https://www.google.com/maps/dir/?api=1&destination=' + dest + '" target="_blank" rel="noopener">Get Directions<span class="sh2-visually-hidden"> to ' + esc(s.store_name) + '</span></a></div></li>';
    }
    function list(stores, compact) { return '<ol class="sh2-stores' + (compact ? ' sh2-stores--compact' : '') + '">' + stores.map(function (s) { return storeHTML(s, compact); }).join('') + '</ol>'; }
    var tipsHTML = '<div class="sh2-locator__section sh2-locator__section--tips"><h3 class="sh2-label">Sherri Hill Tips</h3><ol class="sh2-tips">' + TIPS.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ol></div>';
    function none(label, msg) {
      results.innerHTML = '<div class="sh2-locator__section"><h3 class="sh2-locator__heading">' + (label ? 'No Stores Found Near ' + esc(label) : 'No Stores Found') + '</h3><p class="sh2-locator__empty">' + esc(msg) + '</p></div>';
    }
    var seq = 0;
    function search(loc) {
      lastSearch = loc;
      var n = ++seq;
      setStatus(loc.none ? 'Finding authorized retailers…' : 'Searching authorized retailers near ' + loc.label + '…');
      skeleton();
      var params = { name: style, color: state.color, size: state.size };
      if (!loc.none) { params.latitude = loc.lat; params.longitude = loc.lng; }
      var qs = new URLSearchParams(params);
      fetch(STORE_API + '?' + qs.toString())
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (n !== seq) return;
          var stores = j.stores || [], other = j.other_stores || [];
          if (!stores.length && !other.length) {
            setStatus('');
            none(loc.label, j.message && j.message !== 'found results' ? j.message : 'No authorized retailer' + (loc.none ? '' : ' near ' + loc.label) + ' is listed for Style #' + style + ' in ' + state.color + ', size ' + state.size + '. Try another color or size' + (loc.none ? '.' : ', or search a larger city nearby.'));
            return;
          }
          setStatus((stores.length ? stores.length + (stores.length === 1 ? ' store may' : ' stores may') + ' have this dress.' : '') +
            (loc.none ? ' Search your city or ZIP code to see the closest stores first.' : loc.approx ? ' Showing stores near ' + loc.label + '. Not right? Search your city or ZIP code.' : ''));
          var html = '';
          if (stores.length) html += '<div class="sh2-locator__section"><h3 class="sh2-locator__heading">These Stores May Have Your Dress</h3><p class="sh2-locator__sub">Call ahead to confirm your color and size are in store.</p>' + list(stores) + '</div>';
          else html += '<div class="sh2-locator__section"><h3 class="sh2-locator__heading">' + (loc.none ? 'No Stores List This Dress Yet' : 'No Stores Near ' + esc(loc.label) + ' List This Dress Yet') + '</h3><p class="sh2-locator__empty">Try another color or size, or search a larger city nearby.</p></div>';
          html += tipsHTML;
          if (other.length) html += '<div class="sh2-locator__section"><h3 class="sh2-locator__heading">' + (loc.none ? 'Other Authorized Stores' : 'Other Stores Nearby') + '</h3><p class="sh2-locator__sub">Any authorized Sherri Hill retailer can check whether Style #' + esc(style) + ' is available to order in your color and size.</p>' + list(other, true) + '</div>';
          results.innerHTML = html;
        })
        .catch(function () { if (n !== seq) return; setStatus(''); none(loc.label, 'Store search is unavailable right now. Please try again.'); });
    }

    /* ---------- You May Also Like ---------- */
    var recs = $('[data-sh2-recs]');
    if (recs) {
      var go = function () {
        fetch(recs.getAttribute('data-url'), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var g = doc.querySelector('.sh2-grid-wrap');
            if (!g) { mountVideos(recs); return; }
            var slot = $('[data-sh2-recs-slot]', recs);
            slot.innerHTML = '';
            slot.appendChild(document.importNode(g, true));
            recs.hidden = false;
            mountVideos(recs);
          }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); } }, { rootMargin: '800px' });
        io.observe($('.sh2-pdp__faq') || recs.parentNode);
      } else go();
    }
    function mountVideos(el) {
      $$('[data-sh2-video]', el).forEach(function (box) {
        var btn = box.querySelector('.sh2-media__play');
        var mount = function () {
          if (box.dataset.mounted) return; box.dataset.mounted = '1';
          var v = document.createElement('video');
          v.className = 'sh2-media__video'; v.muted = true; v.loop = true; v.playsInline = true; v.autoplay = true;
          v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
          v.src = box.getAttribute('data-src');
          v.addEventListener('playing', function () { box.classList.add('is-playing'); });
          box.appendChild(v); var p = v.play(); if (p && p.catch) p.catch(function () {});
        };
        if (quiet() || !('IntersectionObserver' in window)) {
          if (btn) { btn.hidden = false; btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); btn.hidden = true; mount(); }); }
          return;
        }
        var o = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { o.disconnect(); mount(); } }, { rootMargin: '200px' });
        o.observe(box);
      });
    }

    render();
    sticky();
  }

  function boot() { document.querySelectorAll('.sh2-pdp').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
